module.exports = __webpack_public_path__ + "static/media/ki.51ced81a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ki.svg
// module id = 2130
// module chunks = 0